module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABO0lEQVRoQ+2YvUoDQRSFvyW9nZA2Aa1SphJS5QnsY2ueKdapLeIjSDrLdClS+AR2NqIMDBiWZZkzuMgNZ5tt7t09P3fOzk5D8KsJjh8T+G8H7UBEB74HBC1PhNwAmECPg7KgcsMlOrAFXivWxQJYtfpkQeWGDgfWwFMFgUdgYwIVyrVTyA6ciSiPtNzgNfArtxdx0sIjBDiFnELix8wfsiyYY9QxmkfBMeoYdYwG/6UM/1MvTmBvubw7lhsu8VyoS9JD3man+zIfn1wXWCULKjcUOPAF3ACnM8D3wHMUAkfgtgX2CviIQuATGLcA3wH7KAQSzhfgIZOYADtgFolAwpqceAemwKgAfNXueIhFXIi1s0zGIzcUpJAJKArUOPCmvECsnYv1VSdz6jsGra9xYFBA6sNNQFXsr+t/AC4VYjFR2CiVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner-phone.png
// module id = MjPp
// module chunks = 1